import { StyledParagraph } from '@components/Text';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { HeadingColor, ImgWH, ImgWidth100, LabelColor, ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import os from '@src/lang/ko/main/os/os';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Card, CardDesc, CardLayout, CardOverlay, ToggleBtn } from '../../Os.style';
import { DivAllCenter, DivFlexColumn } from '@pages/CommonStyle/commonDiv.style';
import { HeadingH3, HeadingH3white } from '@components/Text/Heading/Heading.style';
import { Link } from 'react-router-dom';
import { ShowMoreButton } from '@pages/CommonStyle/commonBtn';
import simple from '@src/lang/ko/simple';
import i18n from '@pages/i18n';
import { IconShowDescOff, IconShowDescOn } from '@assets/images/main/icon';

export const SpaceBar = () => <>&nbsp;</>;

const Section = ({ section, layoutType }) => {
  const [layoutMaxWidth, setLayoutMaxWidth] = useState<any>(null);

  useEffect(() => {
    const handleResize = () => {
      setLayoutMaxWidth(window.innerWidth);
    };
    setLayoutMaxWidth(document.documentElement.clientWidth);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [activeCards, setActiveCards] = useState<Set<number>>(new Set());

  const handleToggle = (idx: number) => {
    setActiveCards((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(idx)) {
        newSet.delete(idx);
      } else {
        newSet.add(idx);
      }
      return newSet;
    });
  };

  return (
    <>
      <SpacingDTM d={'256'} t={'128'} m={'96'} />
      <DivFlexColumn>
        <HeadingColor color={'#818181'} size={'xxxsmall'}>
          <Trans i18nKey={`os.${section}.tag`} />
        </HeadingColor>
        <Spacing pixel="8" />
        <DisplayH2 size={'small'}>
          <Trans i18nKey={`os.${section}.title`} />
        </DisplayH2>
        <Spacing pixel="16" />
        <StyledParagraph size={'medium'}>
          <p>
            <Trans i18nKey={`os.${section}.desc`} components={{ br: layoutType === 'mobile' ? <SpaceBar /> : <br /> }} />
          </p>
        </StyledParagraph>
      </DivFlexColumn>

      <SpacingDTM d={'64'} t={'64'} m={'48'} />

      <CardLayout>
        {os[section].box.map((data, i) => {
          const opened = activeCards.has(i); // ✅ 여러 개 열릴 수 있음

          return (
            <>
              <Card w={layoutMaxWidth} img={data.img[layoutType]} index={data.size}>
                {opened && (
                  <>
                    <CardOverlay />
                    <CardDesc>
                      <DivFlexColumn>
                        <HeadingH3white size={layoutType === 'mobile' ? 'xsmall' : 'small'}>
                          <Trans i18nKey={`os.${section}.box.${i}.title`} />
                        </HeadingH3white>
                        <Spacing pixel="16" />
                        <ParagraphColor size={'small'} color={'#fff'}>
                          <p>
                            <Trans i18nKey={`os.${section}.box.${i}.desc`} />
                          </p>
                        </ParagraphColor>

                        {/* {data.link && (
                          <>
                            <Spacing pixel="16" />
                            <ShowMoreButton href={i18n.language === 'ko' ? data.link : `/${i18n.language}${data.link}`} rel="noopener noreferrer">
                              <img src={simple.showmoreImg[i18n.language]} alt="learn more button" />
                            </ShowMoreButton>
                          </>
                        )} */}
                      </DivFlexColumn>
                    </CardDesc>
                  </>
                )}{' '}
                {/* 토글된 경우에만 오버레이 */}
                <ToggleBtn onClick={() => handleToggle(i)} src={opened ? IconShowDescOff : IconShowDescOn} />
              </Card>
            </>
          );
        })}
      </CardLayout>
    </>
  );
};

export default Section;
